import {
  checkDataUrl,
  checkExtension,
  DOMAdapter,
  ExtensionType,
  LoaderParser,
  LoaderParserPriority
} from 'pixi.js';

/* eslint-disable */
// Disabling eslint due to this being a pixi extension which doesn't necessarily follow our standards.

const validExtension = ['.html', '.css'];
const validTXTMIME = 'text/plain';

/** Pass to `Assets.load({ parser: WEB_FILE_LOADER_ID, ... })` when forcing this loader. */
export const WEB_FILE_LOADER_ID = 'loadWebFile';

/**
 * Loads .html / .css (or data URLs with text/plain) as plain text via fetch.
 * Registered with AssetManager; use explicit `parser: WEB_FILE_LOADER_ID` if resolution would otherwise pick another loader.
 */
export const loadWebFile = {
  id: WEB_FILE_LOADER_ID,
  name: WEB_FILE_LOADER_ID,

  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.High
  },

  test(url: string): boolean {
    return checkDataUrl(url, validTXTMIME) || checkExtension(url, validExtension);
  },

  async load(url: string): Promise<string> {
    const response = await DOMAdapter.get().fetch(url);

    const txt = await response.text();

    return txt;
  }
} as LoaderParser;
